import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/ui/button";

export default function AboutHeroSection() {
  return (
    <div className="relative min-h-[60vh] sm:min-h-[70vh] md:min-h-[80vh] lg:min-h-screen overflow-hidden">
      {/* Background Image */}
      <Image
        src="/image/about/heroSection.png"
        alt="Wheel warehouse"
        fill
        className="object-cover"
        priority
      />
      
      {/* Gradient Overlay */}
      <div 
        className="absolute inset-0" 
        style={{ 
          background: "linear-gradient(287.56deg, rgba(0, 0, 0, 0) 22.62%, rgba(0, 0, 0, 0.6) 45.09%)" 
        }}
      />

      {/* Content */}
      <div className="absolute inset-0 flex items-end">
        <div className="px-4 sm:px-6 md:px-8 lg:px-20 pb-12 sm:pb-16 md:pb-20">
          <div className="max-w-[800px]">
          {/* Label */}
          <p className="font-plus-jakarta text-xs sm:text-sm md:text-base font-medium text-white/80 mb-2 sm:mb-3 md:mb-4">
            About Us
          </p>

          {/* Heading */}
          <h1 className="font-plus-jakarta text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-5 md:mb-6 leading-tight">
            THE HOME OF BUYING AND SELLING WHEELS.
          </h1>

          {/* Description */}
          <p className="font-plus-jakarta text-sm md:text-lg text-white/80 mb-6 sm:mb-7 md:mb-8">
            A trusted platform built to make buying and selling wheels simple, secure, and reliable.
          </p>

          {/* CTA Button */}
          <Link href="/contact">
            <Button
              className="font-plus-jakarta font-bold bg-primary hover:bg-primary/90 text-white h-12 sm:h-13 md:h-14 px-6 sm:px-7 md:px-8 rounded-xl text-sm sm:text-base cursor-pointer"
            >
              Contact Us
            </Button>
          </Link>
        </div>
        </div>
      </div>
    </div>
  );
}
